import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "button"]
    static classes = ["clamped"]

    connect() {
        // Use ResizeObserver for accurate measurements after layout shifts
        this.observer = new ResizeObserver(() => {
            this.checkOverflow()
        })
        this.observer.observe(this.contentTarget)

        // Also trigger immediately after next paint
        requestAnimationFrame(() => this.checkOverflow())
    }

    disconnect() {
        if (this.observer) {
            this.observer.disconnect()
        }
    }

    checkOverflow() {
        // If the text is fully expanded, the button should stay visible to allow collapsing.
        if (!this.contentTarget.classList.contains(this.clampedClass)) {
            this.buttonTarget.classList.remove("hidden")
            return
        }

        // A reliable cross-browser check for line-clamp truncation
        const isOverflowing = this.contentTarget.scrollHeight > this.contentTarget.clientHeight + 2;

        if (isOverflowing) {
            this.buttonTarget.classList.remove("hidden")
        } else {
            this.buttonTarget.classList.add("hidden")
        }
    }

    toggle() {
        if (this.contentTarget.classList.contains(this.clampedClass)) {
            // Expand
            this.contentTarget.classList.remove(this.clampedClass)
            this.buttonTarget.textContent = "Voir moins"
        } else {
            // Collapse
            this.contentTarget.classList.add(this.clampedClass)
            this.buttonTarget.textContent = "Lire la suite..."
            // Re-trigger scroll to top of post if it was very long
            const y = this.element.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }
}
